import { IAutomationAppComponent } from "../../types";
import { schema } from "./types";
import { OverviewPanel,OperatorPanel } from '.';
import { IconCooling } from "./IconCooling";
import { SubplantInsightsPanel } from "../SubPlantInsights";

export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: IconCooling,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    InsightsPanel: SubplantInsightsPanel,
    createConfig:     {
        group: 'SubPlants',
        name: "Cooling generator",
        description: "Cooling generator",
        panel: OverviewPanel,
        defaultState: { isOn: true },
    },
}